<template>
  <div style="height: 100%;background-color: white">
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto;padding-top: 20px">
      <div style="height: 50px;">
        <el-button type="primary" plain icon="el-icon-plus" @click="addServiceProject()">新增</el-button>
      </div>
      <div style="max-height: calc(100% - 100px);overflow-y: auto">
        <el-table :data="tableData" border highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="编号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop=""
            label="名称"
            min-width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop=""
            label="项目类型"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column
            prop=""
            label="添加时间"
            min-width="100"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="openEdit(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delNurse(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="500px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-nurse :addEditObj="addEditObj" v-model="addEditShow"></add-edit-nurse>
    </el-dialog>
  </div>
</template>

<script>
import addEditNurse from './components/addEditNurse'
export default {
  name: 'nurseManagement',
  components: {addEditNurse},
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [{id: 1, name: 11}],
      addEditShow: false,
      addEditTitle: '',
      addEditObj: {
        isAdd: true,
        row: ''
      }
    }
  },
  created () {
  },
  methods: {
    addServiceProject () {
      this.addEditTitle = '新增护理项目'
      this.addEditObj.isAdd = true
      this.addEditShow = true
    },
    openEdit (row) {
      this.addEditTitle = '编辑护理项目'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delNurse (row) {
      let name = row.name
      this.$confirm('此操作将永久删除该护理项目【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/nurseManagement.vue